import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { slide as Menu } from 'react-burger-menu'

import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import estilos from './MenuHamburguesa.module.css';

import {
    faUsers, faUser, faCheckDouble, faCircleInfo, faPerson, faPenToSquare, faRightFromBracket, faGlobe, faEarthAmericas,
    faMagnifyingGlassLocation,faQrcode,faStamp,faUserTie,
} from '@fortawesome/free-solid-svg-icons'

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box, Typography } from "@mui/material";
import BotonMenuHamburguesa from './BotonMenuHamburguesa'
library.add(faUsers, faUser, faPenToSquare, faCircleInfo, faPerson,faMagnifyingGlassLocation,faQrcode,faStamp,faUserTie)

const MenuHamburguesa = (props) => {

    var styles = {
        bmBurgerButton: {
            position: 'fixed',
            width: '36px',
            height: '30px',
            left: '36px',
            top: '26px'
        },
        bmBurgerBars: {
            background: '#F1C77E'
        },
        bmBurgerBarsHover: {
            background: '#a90000'
        },
        bmCrossButton: {
            height: '24px',
            width: '24px'
        },
        bmCross: {
            background: '#F1C77E'
        },
        bmMenuWrap: {
            position: 'fixed',
            height: '100%'
        },
        bmMenu: {
            background: '#072036',
            padding: '2.5em 1.5em 0',
            fontSize: '1.15em'
        },
        bmMorphShape: {
            fill: '#373a47'
        },
        bmItemList: {
            color: '#F1C77E',
            padding: '0.8em'
        },
        bmItem: {
            display: 'inline-block'
        },
        bmOverlay: {
            background: 'rgba(0, 0, 0, 0.3)'
        }
    }

    const currentUser = useSelector(store => store.Usuario.data)
    let idUsuario = 0
    if (currentUser) {
        idUsuario = currentUser.user[0].id
    }
    const dataUser = useSelector(store => store.Usuario.user)
    const [value, setValue] = React.useState("1");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Fragment>
            <div className={`${estilos.header}`}>
                <Fragment>
                    <header className='row text-center'>
                        <div className='col-1'></div>
                        <div className='col-10' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                            <div className='row'>
                                {dataUser?.[0]?.idrol == 1 &&
                                    <div className='col-12 mt-2' >
                                        <span className='textoEscondido text-center' style={{ color: '#F1C77E' }}>
                                            <strong>COMERCAM EN LINEA</strong><br />Administrador 
                                        </span>
                                    </div>
                                }
                            </div>

                        </div>
                        <div className='col-1' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Tooltip title="Salir de la aplicación" arrow>
                                <button style={{ border: 'none', padding: '4px', backgroundColor: 'transparent', color: '#F1C77E', fontFamily: 'Montserrat', boxShadow: 'none', textDecoration: 'none' }} onClick={props.cerrarSesionModal} className="text-wrap text-center botonZoom"> <FontAwesomeIcon style={{ transform: 'scale(1.5)' }} icon={faRightFromBracket} /><br />Salir</button>
                            </Tooltip>

                        </div>

                    </header>
                </Fragment>
            </div>
            <Menu styles={styles}>
                <List className={`${estilos.lista}`}>
                    {dataUser?.[0]?.idrol == 1 &&
                        <Fragment>
                            <BotonMenuHamburguesa titulo="Atención a Clientes" objeto={[]} ruta="/SolicitudesACDireccion" icon={faUserTie}></BotonMenuHamburguesa>
                            <BotonMenuHamburguesa titulo="Unidad de Inspección" objeto={[]} ruta="/TabsUIDGComponent" icon={faMagnifyingGlassLocation}></BotonMenuHamburguesa>
                            <BotonMenuHamburguesa titulo="Panel de Hologramas" objeto={[]} ruta="/PanelConsultaHologramasDGComponent" icon={faQrcode}></BotonMenuHamburguesa>
                            <BotonMenuHamburguesa titulo="División Nacional" objeto={[]} ruta="/TabsOCNacionalDGComponent" icon={faStamp}></BotonMenuHamburguesa>
                            {/*<BotonMenuHamburguesa titulo="División Exportación" objeto={[]} ruta="/ModuloConsultaOCComponent" icon={faEarthAmericas}></BotonMenuHamburguesa>
                            <BotonMenuHamburguesa titulo="Unidad Maguey" objeto={[]} ruta="/ModuloConsultaOCComponent" icon={faCircleInfo}></BotonMenuHamburguesa>*/}
                            <BotonMenuHamburguesa titulo="Módulo de Consulta" objeto={[]} ruta="/TablaClientesComponentDG" icon={faUsers}></BotonMenuHamburguesa>
                        </Fragment>
                    }
                </List>
            </Menu>
            <br /><br /><br /><br />
            {props.componenteCerrarSesionModal}
        </Fragment >
    );
};
export default withRouter(MenuHamburguesa)
